export const GET_GRADES = "GET_GRADES"
export const GET_GRADES_SUCCESS = "GET_GRADES_SUCCESS"
export const GET_GRADES_FAILED = "GET_GRADES_FAILED"